import React from 'react'
import ButtonGroup from 'react-bootstrap/lib/ButtonGroup'
import MenuItem from 'react-bootstrap/lib/MenuItem'
import Dropdown from 'react-bootstrap/lib/Dropdown'
import DropdownToggle from './dropdown_toggle'

class RangeSelector extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            selectedOption: props.defaultSelectedOption,
        }

        this.onClickBackward = this.onClickBackward.bind(this)
        this.onClickForward = this.onClickForward.bind(this)
        this.handleSelect = this.handleSelect.bind(this)
    }


    onClickBackward() {
        if (this.props.onClickBackward) {
            this.props.onClickBackward()
        }
    }

    onClickForward() {
        if (this.props.onClickForward) {
            this.props.onClickForward()
        }
    }

    handleSelect(selectedKey) {
        if (this.props.onSelect) {
            this.props.onSelect(selectedKey)
        }

        this.setState({selectedOption: selectedKey})
    }

    render() {
        return (
            <div className="o-range-selector">
                <ButtonGroup className="range-select">
                    <button type="button"
                        className="btn btn-default back"
                        onClick={this.onClickBackward}>
                        <i className="fa fa-chevron-left" aria-hidden="true"></i>
                    </button>
                    <Dropdown onSelect={this.handleSelect} id="interval-dropdown">
                        <DropdownToggle bsRole="toggle">
                            {this.props.title || ''}
                            <i className="fa fa-chevron-down" aria-hidden="true"></i>
                        </DropdownToggle>

                        <Dropdown.Menu className="super-colors">
                            {this.props.options.map( o =>
                                <MenuItem
                                    active={o.key === this.state.selectedOption}
                                    eventKey={o.key}
                                    key={o.key}
                                >
                                    {o.label}
                                </MenuItem>)}
                        </Dropdown.Menu>
                    </Dropdown>

                    <button type="button"
                        className="btn btn-default"
                        onClick={this.onClickForward}>
                        <i className="fa fa-chevron-right"></i>
                    </button>

                </ButtonGroup>

            </div>
        )
    }
}

export default RangeSelector



// WEBPACK FOOTER //
// ./src/components/range_selector.jsx